/* eslint-disable import/prefer-default-export */
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezonePlugin from 'dayjs/plugin/timezone';
import { TIMEZONE_VN } from 'constant';

dayjs.extend(utc);
dayjs.extend(timezonePlugin);

export const formatDatetime = (date, template, timezone = TIMEZONE_VN) =>
  date ? dayjs(date).tz(timezone).format(template) : '';

export const roundNumber = (num, decimalPlaces = 2) => {
  const value = typeof num === 'number' ? num : parseFloat(num);

  const factor = 10 ** decimalPlaces;
  return Math.round(value * factor) / factor;
};
